export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2caa91b9-e407-4bcb-8437-bfae7e79f861';
export const MODAL_CLOSE_SEC = 2.5;
